export default "__VITE_ASSET__BiS6qdZF__"